import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";

import { RoleType } from "src/app/core/_models/role";
import { UserFacadeService } from "src/app/core/facades/userfacade/userfacade.service";
import { NgIf } from "@angular/common";
import { UserDashboardComponent } from "../../shared/component/user-dashboard/user-dashboard.component";
import { AdminDashboardComponent } from "../../shared/component/admin-dashboard/admin-dashboard.component";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
  imports: [NgIf, UserDashboardComponent, AdminDashboardComponent],
})
export class HomeComponent implements OnInit {
  user;
  name;
  admin;
  customer;
  currentUser;
  public role;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userFacade: UserFacadeService,
  ) {}

  ngOnInit() {
    this.userFacade.user.subscribe((user) => {
      if (user) {
        if (user.permissions.find((role) => role.value == RoleType.HXAMaster)) {
          this.role = "Admin";
        } else {
          this.role = "User";
        }
      }
    });
    this.currentUser = this.route.snapshot.data.user;
  }
}
